import { Button } from "@/components/ui/button";
import { getEffectiveCredits, getPackPriceUsd } from "@/lib/payments/client";

/** A smaller purchase option; uses the parent's checkout and pending state. */
export function MiniPreviewOffer({
  onPurchase,
  disabled,
}: {
  onPurchase: () => void;
  disabled: boolean;
}) {
  const remainingPreviews = Math.max(getEffectiveCredits("mini") - 1, 0);

  return (
    <div className="mt-3 space-y-1 text-center">
      <Button
        type="button"
        variant="outline"
        onClick={onPurchase}
        disabled={disabled}
        className="h-auto min-h-11 w-full whitespace-normal px-3 py-2 text-sm"
      >
        Start small with Mini · ${getPackPriceUsd("mini").toFixed(2)}
      </Button>
      <p className="text-xs text-muted-foreground">
        Unlock this result + {remainingPreviews} more previews. One-time payment.
      </p>
    </div>
  );
}
